






























































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import HelpMessage from "../HelpMessage/HelpMessage.vue";
import Icon from "../Icon/Icon.vue";
import { AColGrid } from "../Pi/components/List/logic/types";
import Tags from "../Tags/Tags.vue";
import { IWizardLikeListItem } from "./types";

@Component({
  components: {
    Icon,
    Tags,
    HelpMessage
  }
})
export default class WizardLikeListItems extends Vue {
  @Prop() items!: Array<IWizardLikeListItem>

  @Prop() grid!: AColGrid | undefined

  @Emit()
  selectItem(item: IWizardLikeListItem) {
    return item
  }

  get calculateSpans():AColGrid {
    const defaultGrid = {
      xs: 24,
      md: 12,
      xl: 8
    }

    if (this.grid !== undefined) {
      return this.grid
    } else {
      return defaultGrid
    }
  }
}
